import Navbar from "@/components/home/Navbar";
import Hero from "@/components/home/Hero";
import Valeurs from "@/components/home/Valeurs";
import ValiditeOrdonnance from "@/components/home/ValiditeOrdonnance";
import Sylvie from "@/components/home/Sylvie";
import Apercu from "@/components/home/Apercu";
import Footer from "@/components/home/Footer";

export default function Home() {
    return (
        <div
            className="min-h-screen font-body bg-lpl-bg text-lpl-text"
            data-testid="home-page"
        >
            <Navbar />
            <main>
                <Hero />
                <Valeurs />
                <ValiditeOrdonnance />
                <Sylvie />
                <Apercu />
            </main>
            <Footer />
        </div>
    );
}
